export function formatDate(date : Date) : string{
    // prettier-ignore
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    if (date !== null) {
        return date.getDate() + ". " + months[date.getMonth()] + " " + date.getFullYear();
    } else {
        return "";
    } 
}
